import { isCloud } from '@blk/aw-env-detection';
import { conditionalParam as baseConditionalParam, ParamExclusionRule } from '../../utils/ApiUtils';
import { awBridgeSettings } from './Base';

export const isAGraphEnabled = () => {
  // Temporarily only using AGraph APIs externally until the legacy internal ones are fixed by AGraph team
  if (isCloud()) {
    return awBridgeSettings.getAGraphConfig?.()?.['aw-api'] ?? false;
  }
  return false;
};

/**
 * Default exclusion rules for AWBridge AGraph/Cloud APIs that reject unknown query params
 */
const AW_BRIDGE_PARAM_EXCLUSION_RULES: ParamExclusionRule[] = [
  {
    urlPrefix: [
      'v1/proposals/createFromAccounts',
      'v1/proposals/createFromAggregate',
      'v1/proposal-entries/paginateUserEntries',
      '/v1/proposal-entries',
      '/v1/portfolios/analyze',
      '/v4/proposals/analyze',
      'v1/sync-proposal-analysis',
      'v1/security/get:resolve',
      '/v1/proposals/share',
    ],
    excludedParams: ['configurationDirectory'],
  },
  {
    urlPrefix: ['/v1/events', '/v2/proposals/bulkGet'],
    excludedParams: ['configurationDirectory', 'pkg'],
  },
  {
    urlPrefix: [
      'v1/proposal-entries/paginateUserEntries',
      '/v1/events',
      '/v1/portfolios/analyze',
      '/v4/proposals/analyze',
      '/v1/proposal-entries',
    ],
    excludedParams: ['viewAs'],
  },
];

/**
 * Returns the parameter value or undefined if it should be excluded for AWBridge endpoints
 * @param url - The API endpoint URL
 * @param paramName - The parameter name
 * @param value - The parameter value
 * @returns The value if not excluded, undefined otherwise
 */
export function conditionalParam<T>(url: string | undefined, paramName: string, value: T): T | undefined {
  return baseConditionalParam(url, paramName, value, AW_BRIDGE_PARAM_EXCLUSION_RULES);
}
